export const USER = 'user';
export const MANAGER  = 'manager';
export const ADMIN  = 'admin';